const Help = ({ actions }) => {
  // console.log("Help actions prop:", actions);

  const handleClick = async (msg) => {
    if (actions && typeof actions.prefillChatInput === "function") {
      actions.prefillChatInput(msg);
    }
    else {
      console.warn(
        "prefillChatInput is not available on actions. actions=",
        actions
      );
    }
  };

  return (
    <div className="flex flex-wrap justify-center gap-2 gap-x-2">
      {/* commented how debug buttons */}
      {/* <button onClick={() => handleClick("get daw state")} className="bg-blue dark:bg-surface text-gray-300 px-4 py-2 rounded-full border-2 border-accent cursor-pointer">Get Daw State</button>
      <button onClick={() => handleClick("get editor contents")} className="bg-blue dark:bg-surface text-gray-300 px-4 py-2 rounded-full border-2 border-accent cursor-pointer">Get Editor Content</button>
      <button onClick={() => handleClick("run result")} className="bg-blue dark:bg-surface text-gray-300 px-4 py-2 rounded-full border-2 border-accent cursor-pointer">Get Script Result</button> */}
      {/* <button onClick={() => handleClick("test")} className="bg-blue dark:bg-surface text-gray-300 px-4 py-2 rounded-full border-2 border-accent cursor-pointer">Test</button> */}
    </div>
  );
};

export default Help;